define("shared/helpers/rebase-indexed-number", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.rebaseIndexedNumber = rebaseIndexedNumber;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f
  /**
   * Returns the given number plus 1.
   *
   * @method rebaseIndexedNumber
   * @param {Number} number Current index
   *
   * @return {Number} Current index + 1
   */
  function rebaseIndexedNumber(_ref /*, hash*/) {
    let [number] = _ref;
    return number + 1;
  }
  var _default = _exports.default = (0, _helper.helper)(rebaseIndexedNumber);
});